/** React island mount attribute used to scope rp-ui and MUI Emotion styles. */
const ISLAND_ROOT_SELECTOR = '[data-react-island-root]';

/** In-tree portal target so MUI overlays stay inside island style scope. */
const ISLAND_PORTAL_HOST_SELECTOR = '[data-island-portal-host]';

/**
 * @param {string} selector
 * @returns {string[]}
 */
function scopeSelectorEntries(selector) {
	const trimmed = selector.trim();

	if (trimmed === ':root' || trimmed === 'html') {
		return [ISLAND_ROOT_SELECTOR];
	}

	if (isIslandScopedSelector(trimmed)) {
		return [trimmed];
	}

	return [
		`${ISLAND_ROOT_SELECTOR} ${trimmed}`,
		`${ISLAND_PORTAL_HOST_SELECTOR} ${trimmed}`,
	];
}

/**
 * @param {string} selector
 * @returns {string}
 */
function scopeSelector(selector) {
	return scopeSelectorEntries(selector).join(', ');
}

/**
 * @param {string} selector
 * @returns {boolean}
 */
function isIslandScopedSelector(selector) {
	const trimmed = selector.trim();

	return trimmed.startsWith(ISLAND_ROOT_SELECTOR)
		|| trimmed.startsWith(ISLAND_PORTAL_HOST_SELECTOR);
}

/**
 * @param {string} selector
 * @returns {boolean}
 */
function isKeyframeStepSelector(selector) {
	const trimmed = selector.trim();

	return trimmed === 'from'
		|| trimmed === 'to'
		|| /^\d+\.?\d*%$/.test(trimmed);
}

/**
 * @param {string | string[]} selectors
 * @returns {string[]}
 */
function scopeRuleSelectors(selectors) {
	const selectorList = Array.isArray(selectors) ? selectors : [String(selectors)];

	if (selectorList.length > 0 && selectorList.every(isKeyframeStepSelector)) {
		return selectorList;
	}

	return selectorList.flatMap(scopeSelectorEntries);
}

/**
 * @param {string | string[]} selectors
 * @returns {boolean}
 */
function includesDocumentRootSelector(selectors) {
	const selectorList = Array.isArray(selectors) ? selectors : [String(selectors)];

	return selectorList.some((selector) => {
		const trimmed = selector.trim();

		return trimmed === ':root' || trimmed === 'html';
	});
}

module.exports = {
	ISLAND_PORTAL_HOST_SELECTOR,
	ISLAND_ROOT_SELECTOR,
	includesDocumentRootSelector,
	isIslandScopedSelector,
	isKeyframeStepSelector,
	scopeRuleSelectors,
	scopeSelectorEntries,
	scopeSelector,
};
